import { useFormatter } from 'use-intl';
import { DateLabel } from '@leanin/ui/client';

interface Props {
  readonly value: Date | string;
  readonly className?: string;
}

/**
 * Renders a self-updating relative time string ("5m ago", "3 days ago").
 * Ticks automatically; updates are silent (no live-region announcement).
 */
export function RelativeDate({ value, className }: Props) {
  const formatter = useFormatter();
  return (
    <DateLabel
      value={value}
      format={(d) => formatter.relativeTime(d)}
      className={className}
    />
  );
}
